module.exports = __webpack_public_path__ + "img/icon_kehu_01.4841ee45.png";